module.exports = __webpack_public_path__ + "img/bingyan.30c2040b.png";